/*
 * Copyright (c) 2026. Tooling Team
 */

// This file contains utility functions related to mapping details, such as applying map details to the state.
import {
  setMapVersion,
  setMapStatus,
  setIsEditableVersion,
  setMapTags,
  setMapID,
  setMapAttributes,
  setRowData,
  setMapColumns,
} from "../app/slices/EIPMapValueDefinition.slice";
import { transformMVApiResponse, deriveMapColumnSections } from "./funcs";

export const applyMapDetailsToState = (
  dispatch,
  mapData,
  { recordsOverride, shouldTransform = true } = {}
) => {
  if (!mapData) {
    return;
  }

  dispatch(setMapVersion(mapData.version));
  dispatch(setMapStatus(mapData.status));
  dispatch(setIsEditableVersion(mapData.isEditableVersion));
  dispatch(setMapTags(mapData.tags ? mapData.tags : []));

  const records = recordsOverride || mapData.mapElements?.records || [];
  if (shouldTransform) {
    transformMVApiResponse(records);
  }
  dispatch(setRowData(records));
  dispatch(
    setMapColumns(
      deriveMapColumnSections(mapData.mapElements?.columns || [], records)
    )
  );
  dispatch(setMapID(mapData._id));

  const mapAttrs = {};
  mapData.attributes?.forEach((element) => {
    mapAttrs[element.name.replace(/\s/g, "")] = {
      value: element.values.join(", "),
      name: element.name,
      editable: !!element.editable,
      updated: element.updated,
      allowClone: element.allowClone,
    };
  });
  dispatch(setMapAttributes(mapAttrs));
};
